exports.fetchLink = 'https://orders.sziszakebab.pl/' 
//exports.fetchLink = 'http://192.168.0.193:5000/'